import { Controller } from "@hotwired/stimulus";

// Contextual action sheet -- a bottom sheet populated from <template> elements.
// Listens for "action-sheet:open" on window with detail.templateId.
export default class extends Controller {
  static targets = ["overlay", "sheet", "content"];

  connect() {
    this._boundOpen = (e) => this._open(e);
    this._boundCloseOnPanel = () => this.close();
    window.addEventListener("action-sheet:open", this._boundOpen);
    window.addEventListener("mobile-panel:open", this._boundCloseOnPanel);
  }

  disconnect() {
    clearTimeout(this._closeTimer);
    window.removeEventListener("action-sheet:open", this._boundOpen);
    window.removeEventListener("mobile-panel:open", this._boundCloseOnPanel);
  }

  close() {
    this.sheetTarget.classList.add("translate-y-full");
    this._closeTimer = setTimeout(() => {
      this.overlayTarget.classList.add("hidden");
      this.contentTarget.innerHTML = "";
    }, 300);
  }

  // Private

  _open(event) {
    const templateId = event.detail?.templateId;
    if (!templateId) return;

    const template = document.getElementById(templateId);
    if (!template) return;

    clearTimeout(this._closeTimer);
    this.contentTarget.replaceChildren(template.content.cloneNode(true));
    this.overlayTarget.classList.remove("hidden");
    requestAnimationFrame(() => {
      this.sheetTarget.classList.remove("translate-y-full");
    });
  }
}
